import styled from 'styled-components';
import Colors from "modules/Colors";

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
`;

export const TextButton = styled.span`
  color: ${Colors.purple};
  font-family: 'DIN';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
`;